<div *ngIf="!showResult" class="flex justify-center fullscreen-center" style="">
    <p-knob
        [formControl]="progressControl"
        [readonly]="true"
        [showValue]="false"
        [strokeWidth]="5"
        [min]="0"
        [max]="100"
        [valueColor]="'#007ad9'"
        [rangeColor]="'#c8c8c8'">
    </p-knob>
</div>
<div *ngIf="!showResult" class="flex justify-center fullscreen-center">
    <p class="waiting-text">{{ 'sipo.document-signing-component.confirm-document-sign-component.signing-in-progress-message' | translate }}</p>
</div>

<!-- Erfolgs- / Fehlermeldung -->
<div
    class="flex flex-column align-items-center justify-center w-full rounded-lg shadow-lg"
    [ngClass]="{
      'text-black border border-black': succefull === true,
      'text-red-800 border border-red-400': succefull === false
    }"
    *ngIf="showResult">
    <div>
        <strong class="text-2xl">
            <ng-container *ngIf="succefull">
                {{ 'sipo.document-signing-component.confirm-document-sign-component.successfully-signed-message' | translate }}
            </ng-container>
            <ng-container *ngIf="succefull === false">
                {{ 'sipo.document-signing-component.confirm-document-sign-component.signing-failed-message' | translate }}
            </ng-container>
        </strong>
    </div>


    <div class="text-8xl mt-4 text-center">
        <ng-container *ngIf="succefull; else errorIcon">
            <img src="assets/images/sipo/okimza.svg">
            <p class="text-center
">
                <a href="/" class="font-large">
                    {{ 'sipo.document-signing-component.confirm-document-sign-component.redirect-to-sipo' | translate }}
                </a>
            </p>
        </ng-container>
        <ng-template #errorIcon>
            <img src="assets/images/sipo/nokimza.svg">
        </ng-template>
    </div>

</div>
